$(document).ready(function () {
  require('../Contrib/dlmenu/jquery.dlmenu');
  require('./Navigation/initialization');
  require('./Navigation/mainNav');
  require('./SwiperSlider/NewsSlider');
  require('./Helper/back-to-top');
  require('./Helper/additional');
  require('./Helper/SocialShare');

});


